import { consumerCenterPreLoginURLs } from "../EnvUtils";
import { PathName } from '../utils/UrlUtils';
import { getHtmlCheckBoxValue, getHtmlInputValue } from '../utils/HtmlUtils';
import { CookieLoader } from '@alme/session-ts';
import { CookieAlmeSessionDataLoader } from '@alme/session-ts/CookieAlmeSessionDataLoader';
import * as Loaders from '@alme/storage-ts/CookieLoader';
/**
 * RC Pre-login siteidentifier
 */
const dservice = "dservice";
/**
 * Universal siteidentifier
 */
const universalidp = "universal-idp";
/**
 * RC Post-login siteidentifier for Desktop devices
 */
const eservice = "eservice";
/**
 * RC Post-login siteidentifier for Mobile devices
 */
const mservice = "mservice";
/**
 * RC Paypal Post-login siteidentifier
 */
const eservice_ess = "eservice_ess";
/**
 * RC Paypal mobile post-login siteidentifier
 */
const mservice_mss = "mservice_mss";
/**
* Consumer center MySynchrony page
*/
const msync = "msync";
/**
 * Consumer center care credit page
 */
const carecredit = "carecredit.com";
/**
 * Consumer center care credit pre and post login page
 */
const consumercentercc = "cctr-cc";
/**
* Consumer center payment solution pre and post login page
*/
const consumercenterps = "cctr-ps";
/** Consumer center new pre login page */
const idp = "idp";
/**
 * bnpl siteidentifier
 */
const bnplservicing = "bnplservicing";
/**
 * bnpl post login
 */
const setpay = "setpay";
/**
 * peaks Site identifier
 */
const peaks = "peaks";
export function getSiteIdentifier() {
    return window._SFDDL && window._SFDDL.pageInfo && window._SFDDL.pageInfo.SiteIdentifier && window._SFDDL.pageInfo.SiteIdentifier.toLowerCase();
}
export function isRC() {
    const siteIdentifier = getSiteIdentifier();
    return (siteIdentifier === mservice_mss
        || siteIdentifier === eservice_ess
        || siteIdentifier === mservice
        || siteIdentifier === eservice
        || siteIdentifier === dservice);
}
export function isUniversal() {
    const siteIdentifier = getSiteIdentifier();
    return siteIdentifier === universalidp;
}
export function isBNPL() {
    const siteIdentifier = getSiteIdentifier();
    return (siteIdentifier === bnplservicing || siteIdentifier === setpay);
}
export function isBNPLServicingLoggedIn() {
    const eChatPostLoginSessionIDValue = getHtmlInputValue("eChatPostLoginSessionID");
    const isEChatPostLoginSessionIDValueAvailable = (typeof eChatPostLoginSessionIDValue === 'string' && eChatPostLoginSessionIDValue.trim().length >= 1);
    return isBNPL() && isEChatPostLoginSessionIDValueAvailable;
}
export function getCurrentAccount() {
    return sessionStorage.getItem('currentSelectedAccount') || undefined;
}
export function isPeaksLoggedIn() {
    const currentSelectedAccount = getCurrentAccount();
    const iscurrentSelectedAccountAvailable = (typeof currentSelectedAccount === 'string' && currentSelectedAccount.trim().length >= 1);
    return isPeaks() && iscurrentSelectedAccountAvailable;
}
export function isRCLoggedIn() {
    const siteIdentifier = getSiteIdentifier();
    return (siteIdentifier === mservice_mss || siteIdentifier === eservice_ess || siteIdentifier === mservice || siteIdentifier === eservice);
}
export function isRCPostLoginMobile() {
    const siteIdentifier = getSiteIdentifier();
    return siteIdentifier === mservice;
}
export function isCCTR() {
    const siteIdentifier = getSiteIdentifier();
    return (siteIdentifier === msync
        || siteIdentifier === carecredit
        || siteIdentifier === consumercentercc
        || siteIdentifier === consumercenterps
        || siteIdentifier === idp);
}
export function isCCTRLoggedIn() {
    const siteIdentifier = getSiteIdentifier();
    const isPreLoginURL = consumerCenterPreLoginURLs && consumerCenterPreLoginURLs.find((url) => PathName.endsWith(url));
    return (siteIdentifier === consumercentercc || siteIdentifier === consumercenterps) && !!(window.ivaLoginAcctId && window.ivaLoginAcctId !== "null") && (!isPreLoginURL);
}
export function isPeaks() {
    const siteIdentifier = getSiteIdentifier();
    const peaksPlatformIndicatorToggle = getHtmlCheckBoxValue("peaksPlatformIndicatorToggle");
    return siteIdentifier === peaks || peaksPlatformIndicatorToggle === true;
}
export function generatePlatformValue(platform) {
    const siteIdentifier = getSiteIdentifier();
    switch (siteIdentifier) {
        case (eservice_ess):
            platform = "PPC eService";
            break;
        case (mservice):
            platform = "RC mSS";
            break;
        case (mservice_mss):
            platform = "PPC mService";
            break;
        case (dservice):
            platform = "RC dsecurity";
            break;
        case (eservice):
            platform = "RC eService";
            break;
    }
    return platform;
}
export function getSessionLoader() {
    if (isPeaks()) {
        const storageLoader = new Loaders.CookieLoader('almePeaksSession');
        return new CookieAlmeSessionDataLoader(storageLoader);
    }
    else {
        return CookieLoader;
    }
}
